var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle2Fa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9172 9.72043C17.9172 10.4765 17.3044 11.0894 16.5483 11.0894H11.8233L9.79199 6.98213L11.9845 3.18468C12.3625 2.52996 13.1997 2.30563 13.8544 2.68359L13.8547 2.68374C14.5095 3.06174 14.7338 3.89897 14.3558 4.55374L12.1633 8.3515H16.5483C17.3044 8.3515 17.9172 8.96439 17.9172 9.72043Z",
    fill: "#1A73E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8546 16.7561L13.8543 16.7562C13.1996 17.1342 12.3624 16.9099 11.9844 16.2551L9.79189 12.4577L7.59937 16.2551C7.22136 16.9099 6.38419 17.1342 5.72945 16.7562L5.72919 16.7561C5.07441 16.3781 4.85004 15.5409 5.22805 14.8861L7.42055 11.0883L9.79189 11L12.1632 11.0883L14.3557 14.8861C14.7337 15.5409 14.5094 16.3781 13.8546 16.7561Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79189 6.98213L9.17366 8.66062L7.42055 8.3515L5.22805 4.55374C4.85004 3.89897 5.07441 3.06174 5.72919 2.68375L5.72945 2.68359C6.38419 2.30563 7.22136 2.52996 7.59937 3.18468L9.79189 6.98213Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43873 8.35156L7.849 11.0894H3.03567C2.27964 11.0894 1.66675 10.4765 1.66675 9.72049C1.66675 8.96445 2.27964 8.35156 3.03567 8.35156H9.43873Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1633 11.0896H7.42065L9.79199 6.98242L12.1633 11.0896Z",
    fill: "#185DB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle2Fa);
export default __webpack_public_path__ + "static/media/google-2fa.0cc38a92986950d98afba621169facb8.svg";
export { ForwardRef as ReactComponent };